



















import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import Avatar from '@/components/Profil/Avatar.vue'

@Component({
    components: {
        Avatar,
    },
})
export default class HasAnswered extends Vue {
    @Prop() users: any[]
    @Prop({ default: 40 }) size: number

    @Watch('users', { deep: true, immediate: true })
    onUsers() {
        requestAnimationFrame(() => {
            const $root = this.$refs.root as any
            const $popovers = $($root).find('.popover-dismiss') as any

            $popovers.popover({
                trigger: 'hover',
                template: `
                    <div class="popover popover-yvivre p-0 rounded-pill border-0 bg-dark" role="tooltip">
                        <div class="arrow"></div>
                        <h3 class="popover-header"></h3>
                        <div class="popover-body py-1 text-white"></div>
                    </div>
                `,
                container: 'body',
                boundary: 'window',
            })
        })
    }
}
